import { Transition } from "@headlessui/react";
import { InView, useInView } from "react-intersection-observer";
import { useState, useEffect } from "react";
import { premium, classic } from "./content.js";
import top from "./images/logos/top.jpg";
import Nathier from "./Nathier.js";

const breakPoints = "md:w-[750px] w-[400px] sm:w-[580px] lg:w-[900px]";

const Header = () => (
  <div className={`flex flex-row ${breakPoints}`}>
    <div className="flex flex-row justify-center items-center">
      <img src={top} alt="standard bank" className="w-[250px] hidden lg:block" />
      <div className="flex flex-col justify-start items-start pt-10">
      <span className="text-black md:text-4xl font-bold uppercase">Africa's</span>
      <div className="text-topHead text-[50px] md:text-[120px] leading-none font-bold font-bentonModernBold uppercase tracking-wide">      
        Top Employers
      </div>
      </div>
    </div>
  </div>
);

const Footer = () => (  
  <div className="flex flex-col justify-start max-w-[950px] w-full py-2 pb-10">    
  <div>
      <hr className="w-full border-1 border-gray-400" />
    </div>


</div>
)

const BrandVoiceDisclaimer = () => (
  <div className={`flex flex-col justify-start ${breakPoints} w-full py-2`}>
    <div
      className={`flex flex-row justify-end gap-10 items-center ${breakPoints} w-full mb-5`}
    >
      <div className="flex flex-row ">
        <div className="text-black text-sm font-roboto font-semibold pt-3 tracking-wide">
          {" "}
          <span className="text-red uppercase font-semibold">BrandVoice</span> |
          Paid Program
        </div>
      </div>
    </div>
    <div>
      <hr className="w-full border-1 border-gray-400" />
    </div>
    <div className="text-black text-xs font-roboto font-bold pt-3">
      May 11, 2024, 09:00pm CAT
    </div>
  </div>
);


const Companies = ({premium, index, count, cols}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const handleClick = (item) => {
    setSelectedCompany(item);
    setShowModal(true);
    //set scroll back to top
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const newArrayOfCompanies = premium.slice(index, count);

  
let gridColsFormat = `grid grid-cols-2 lg:grid-cols-5 gap-9 justify-center items-center`;
if(cols == 3){
  gridColsFormat = `grid grid-cols-2 lg:grid-cols-3 gap-9 justify-center items-center`;
}
if(cols ==4){
  gridColsFormat = `grid grid-cols-2 lg:grid-cols-4 gap-9 justify-center items-center`;
}



  return (
    <div className={gridColsFormat}>
      {newArrayOfCompanies.map((item) => (
        <div key={item.id}>
          <div
            className="flex flex-col justify-center items-center w-[170px] cursor-pointer"
            onClick={() => handleClick(item)}
          >
            <img
              src={item.logo}
              alt={item.name}
              className="w-full hover:opacity-50 "
            />
          </div>
          <Modal
            isOpen={showModal}
            onClose={handleClose}
            content={selectedCompany}
          />
        </div>
      ))}
    </div>
  );
};


const Modal = ({ isOpen, onClose, content }) => {
  return (
    <div
      className={`fixed top-0 left-0 w-full h-full bg-white bg-opacity-90 flex flex-col z-50 justify-center items-center ${
        isOpen ? "block" : "hidden"
      }`}
    >
      <button className="text-black" onClick={onClose}>
        Close
      </button>
      {/* Modal content here */}
      {content && (
        <div className={`${breakPoints} overflow-y-scroll pt-14 md:pt-0 `}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-9 justify-center items-center">
          <div className="text-black pb-10 flex flex-col justify-center items-center">
            <img
              src={content.image}
              alt={content.attribution}
              className="max-w-[350px]"
            />
            <div className="text-lg uppercase font-semibold text-center">
              {content.attribution}
            </div>
          </div>

          <div className="text-black font-markWebPro">
            <div className="modal-question">
              <div className="text-black text-md pb-5">
                {content.blurb} - {content.attribution}
              </div>
            </div>
          </div>
          </div>
        </div>
      )}

      <button className="text-black" onClick={onClose}>
        Close
      </button>
    </div>
  );
};


const TopEmployer = () => {
  return (
    <div className={`bg-white w-full h-full`}>
      <div className={`flex flex-col items-center justify-center`}>
        <div className={`flex flex-col items-center justify-center`}>
          <Header />
          <BrandVoiceDisclaimer />
          <Nathier breakPoints={breakPoints} />
          <div className="flex flex-col items-center justify-center">
            <span className="text-topHead text-4xl font-bold py-6 mb-2">
              Featured Companies
            </span>
            <div className="flex flex-col items-center justify-center gap-10">

            <Companies premium={premium} index={0} count={5} cols={5} />
            <Companies premium={premium} index={5} count={10} cols={5} />
            
            
            <Companies premium={classic} index={0} count={4} cols={4}/>
            <Footer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopEmployer;
